<script lang="ts">
    import {getSimilar} from 'src/components/main/#services/marketplace'
    import NftCard from 'src/components/main/marketplace/components/nft-card/NftCard.svelte'

    export let productId
    export let type

    $: productId, update()

    update()

    function update() {
        getSimilar.reset()
        getSimilar.send({ data: { productId, type } })
    }
</script>

<section class="more-nft-section catalog">
    <div class="nft-info">
        <div class="container">
            {#if !$getSimilar.hasValue && $getSimilar.loading}
                <div class="section-title">Loading...</div>
            {:else if !$getSimilar.hasValue && $getSimilar.error }
                <div class="section-title">Something went wrong</div>
            {:else if $getSimilar.hasValue && $getSimilar.value.length}
                <div class="section-title">This also buys</div>
                <div class="row nft-cards">
                    {#each $getSimilar.value as item, i}
                        <div class="col-xl-3 col-lg-4 col-6"
                            class:d-lg-none={$getSimilar.value.length == i+1}
                            class:d-xl-block={$getSimilar.value.length == i+1}>
                            <NftCard item={item} on:changed={update}/>
                        </div>
                    {/each}
                </div>
            {/if}
        </div>
    </div>
</section>

<style>
    .more-nft-section {
        position: relative;
    }

    .section-title {
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-weight: 400;
        color: white;
        margin: 40px 0 50px;
        line-height: 50px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .nft-cards {
        margin-bottom: 200px;
    }

    @media(max-width: 1199px) {
        .nft-cards {
            margin-bottom: 150px;
        }

        .nft-cards {
            margin-bottom: 100px;
        }
    }

    @media(max-width: 767px) {
        .section-title {
            font-size: 24px;
            line-height: 1.4;
        }

        .nft-cards {
            margin: 0 -6px 50px;
        }

        .nft-cards .col-6 {
            padding: 0 6px;
        }
    }
</style>
